"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Close = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Close = function Close(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.82 23.998l10.592-10.572c.784-.784.784-2.055 0-2.838-.783-.784-2.054-.784-2.838 0L24.002 21.18 13.429 10.588c-.784-.784-2.054-.784-2.838 0-.784.783-.784 2.054 0 2.838l10.593 10.572L10.59 34.571c-.378.375-.591.886-.591 1.419s.213 1.044.591 1.419c.375.378.886.591 1.42.591.532 0 1.043-.213 1.418-.591l10.573-10.593L34.574 37.41c.376.378.886.591 1.42.591.532 0 1.043-.213 1.418-.591.379-.375.591-.886.591-1.42 0-.532-.212-1.043-.59-1.418L26.82 23.998z"
  }));
};

exports.Close = Close;